<template>
  <div class="mapboxgl-custom-legend">
    <!-- projects -->
    <v-card class="legend-container">
      <div class="pa-3">
        <h4 class="caption font-weight-bold mb-2">Projects</h4>

        <v-layout row wrap align-center>
          <v-flex xs2>
            <div class="legend__rail" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Rail Lines</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__oil" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Oil Lines</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__gas" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Gas Lines</div>
          </v-flex>

          <v-flex xs2>
            <div class="legend__ports" />
          </v-flex>

          <v-flex xs10 class="mb-1">
            <div class="caption">Ports</div>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'LegendFinal',
};
</script>

<style lang="stylus" scoped>
.legend-container {
  width: 40vw;

  .legend__rail {
    width: 50%;
    height: 2px;
    background-color: #e84136;
  }

  .legend__oil {
    width: 50%;
    height: 5px;
    background-color: #5a618a;
  }

  .legend__gas {
    width: 50%;
    height: 5px;
    background-color: #969d86;
  }

  .legend__ports {
    width: 12px;
    height: 12px;
    background-color: #479a89;
    border: 1px solid #5E9889;
    border-radius: 50%;
  }
}
</style>
